import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import {
  Checkbox,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useManualQuery, useMutation } from "graphql-hooks";
import AlertDialog from "../../components/AlertDialog.js";

import { GET_ALL_TEAMS_QUERY } from "../../graphQL/team_qry";
import { 
  GET_ALL_TEAMS_IN_TERM_QUERY,
  CREATE_TEAM_TERM_MUTATION,
  DELETE_TEAM_TERM_MUTATION
} from "../../graphQL/team_term_qry"

import { 
  GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY,
  DELETE_TEAM_TERM_MEMBER_MUTATION
} from "../../graphQL/team_term_member_qry"

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }, 
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },    
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },    
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E3F2FD",
    },    
  },
}));

export default function AssignTeamInputDialog({
  closeDialog,
  currTerm
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [clientTeams, setClientTeams] = useState([]);
  const [teamTermData, setTeamTermData] = useState([]);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
 
  let clientId = 1;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");

  const [fetchClinetTeamsList] = useManualQuery(GET_ALL_TEAMS_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchTeamTermList] = useManualQuery(GET_ALL_TEAMS_IN_TERM_QUERY, {
    fetchPolicy: "network-only",
  });

  const [createTeamTerm] = useMutation(CREATE_TEAM_TERM_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteTeamTerm] = useMutation(DELETE_TEAM_TERM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const [fetchTeamTermMemberList] = useManualQuery(
    GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY, {
    fetchPolicy: "network-only",
  });

  const [deleteTeamTermMember] = useMutation(
    DELETE_TEAM_TERM_MEMBER_MUTATION, {
    fetchPolicy: "network-only",
  });
 
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  useEffect(() => {
    (() => getTeamslist())();
  }, []);  
  
  const getTeamslist = async () => {
    const {
      loading: loadingClientTeams,
      error: errorClientTeams,
      data: dataClientTeams,
    } = await fetchClinetTeamsList({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    const {
      loading: loadingTeamTerm,
      error: errorTeamTerm,
      data: dataTeamTerm,
    } = await fetchTeamTermList({
      variables: {
        termId: parseInt(currTerm.id),
      },
    });

    if (!loadingTeamTerm && 
        dataTeamTerm && dataTeamTerm.getAllTeamsInTerm) {

      if (!loadingClientTeams && 
          dataClientTeams && dataClientTeams.allTeams) {
        let teamList = dataClientTeams.allTeams.map((item, index) => ({
          ...item,
          id: index,
          checked: dataTeamTerm.getAllTeamsInTerm.find(
            teamTerm => teamTerm.teamId.teamId === item.teamId)
            ? true
            : false,
        }));
        
        setClientTeams(teamList);
      };
      setTeamTermData(dataTeamTerm.getAllTeamsInTerm);
    };
  };
  
  const columns = [
    {
      field: "name",
      headerName: "Team Name",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerClassName: "super-app-theme--header",
      headerName: "Team Description",
      minWidth: 170,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "select",
      headerClassName: "super-app-theme--header",
      headerName: "Select",
      minWidth: 70,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return( 
          <Checkbox
            onChange={handleCheckBoxChange}
            id={rows.row.id}
            checked={rows.row.checked}
          />
        )        
      },
    },
  ];

  const rows = clientTeams.map((team, index) => 
    ({ 
      id: index,
      name: team.name,
      decs: team.decs,
      checked: team.checked,
    })
  );
  
  const handleCheckBoxChange = e => {
    let chgClientTeams = findAnd.changeProps(
      clientTeams,
      { id: parseInt(e.target.id) },
      {
        checked: e.target.checked,
      }
    );
    setClientTeams(chgClientTeams);
  };
  
  const handleDone = async () => {
    let hasMemberTeamTerms  = [];
    let noMemberTeamTerms   = [];
    let createdTeamTerms    = [];
    for (let i = 0; i < clientTeams.length; i++) {
      let foundTeamTerm = teamTermData.find(
        teamTerm => teamTerm.teamId.teamId === clientTeams[i].teamId
      );
      // If team checkbox is false and team was assigned before, remove it
      if (!clientTeams[i].checked && foundTeamTerm){
        // If team term has any member asks and deletes memebers first
        const {
          loading: loadingGetTeamTermMember,
          error: errorGetTeamTermMember,
          data: dataGetTeamTermMember,
        } = await fetchTeamTermMemberList({
          variables: {
            teamTermId: parseInt(foundTeamTerm.teamTermId),
          },
        });
        if (!loadingGetTeamTermMember && 
            dataGetTeamTermMember && 
            dataGetTeamTermMember.getAllMembersInTeamTerm) {
          if (!dataGetTeamTermMember.getAllMembersInTeamTerm.length){
            noMemberTeamTerms.push(foundTeamTerm.teamTermId);
          }
          else{
            hasMemberTeamTerms.push(
              {id:foundTeamTerm.teamTermId,
              name: foundTeamTerm.teamId.name });            
          };          
        };
        if (errorGetTeamTermMember) {
          if (errorGetTeamTermMember.graphQLErrors[0].message === "Signature has expired")
            alert(errorGetTeamTermMember.graphQLErrors[0].message);
        }
      }
      // If team checkbox is true and team was not assigned before, assign it
      else if (clientTeams[i].checked && !foundTeamTerm){
        createdTeamTerms.push(clientTeams[i]);              
      };
    };
    saveTeamTermRecords(
      hasMemberTeamTerms,
      noMemberTeamTerms,
      createdTeamTerms
    );
  };

  const deleteTeamTermRec = async(teamsTermId) => {
    for (let i = 0; i < teamsTermId.length; i++) {
      const {
        loading: loadingDeleteTeamTerm,
        error: errorDeleteTeamTerm,
        data: dataDeleteTeamTerm,
      } = await deleteTeamTerm({
        variables: {
          teamTermId: parseInt(teamsTermId[i]),
        },
      }); 
    };
    closeDialog && closeDialog();    
  };

  const createTeamTermRec = async(teams, closeFlg = false) => {
    for (let i = 0; i < teams.length; i++) {
      const {
        loading: loadCreateTeamTerm,
        error: errorCreateTeamTerm,
        data: dataCreateTeamTerm,
      } = await createTeamTerm({
        variables: {
          termId: parseInt(currTerm.id),
          teamId: parseInt(teams[i].teamId),
          goal: "",            
        },
      });      
      if (errorCreateTeamTerm) {
        alert("Unfortunately an error occurred.");
      };
    };
    closeFlg && closeDialog && closeDialog();
  };

  const saveTeamTermRecords = (
    hasMemberList,
    noMemberList,
    createdList
  ) => {

    if (hasMemberList.length){ 
      createdList.length && createTeamTermRec(createdList); 
      setAlertDeleteMsg({
        title: "Delete Team Term",
        type: "deleteConfirmation",
        msg: hasMemberList.map(({ name }) => name).join() +
          " has one or more members." + 
          " Are you sure to delete members and unassign team term?",
        teamsTermId: hasMemberList.map(({ id }) => id).concat(noMemberList),
      });
    }
    else if (noMemberList.length)
    {
      createdList.length && createTeamTermRec(createdList);
      deleteTeamTermRec(noMemberList);
    }
    else
    {
      createdList.length && createTeamTermRec(createdList, true);
    };    
  };
  
  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              height: "600px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}
            style={{ textAlign:"left" }}
          >
            Assign Team(s) to term: <b>{currTerm.name}</b><br />
            Client: <b>{clientName}</b>
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Box pt={1} pb={1} style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Select team(s)
            </Typography>
          </Box>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            autoWidth={true}
            getRowId={row => row.id}
            getRowClassName={params => {
              if (params.row.id % 2 === 0) return "even";
              else return "odd";
            }}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
          />            
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                deleteTeamTermRec(alertDeleteMsg.teamsTermId);
                setAlertDeleteMsg([]);
              }}
            />
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleDone}
            >
                Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
